import { PropsWithChildren } from 'react';

import styles from './full-view-dialog.module.scss';

export type DialogContentProps = PropsWithChildren;

const DialogContent = ({ children }: DialogContentProps) => (
    <div className={styles.dialogContent}>{children}</div>
);

export { DialogContent };
